@if (uiStore.feedbackTemplateOpen()) {
  <app-feedback></app-feedback>
}
<router-outlet></router-outlet>